import { ProtoRequest } from '@lsq-frontend/angular-shared/api-service';

export class UpdateAllPaymentOptInRequest extends ProtoRequest {
    public optIn: boolean;
    public sellerKey: string;
    public terms: number;
    public termsActive: boolean;
    constructor(obj?: {
       optIn?: boolean;
       sellerKey?: string;
       terms?: number;
       termsActive?: boolean;
    }) {
        super();
        if (obj != null) {
            this.optIn = typeof obj.optIn === 'undefined' ? this.optIn : obj.optIn;
            this.sellerKey = typeof obj.sellerKey === 'undefined' ? this.sellerKey : obj.sellerKey;
            this.terms = typeof obj.terms === 'undefined' ? this.terms : obj.terms;
            this.termsActive = typeof obj.termsActive === 'undefined' ? this.termsActive : obj.termsActive;
        }
    }
}
